import './query-input.scss'

import { defineComponent } from 'vue'
import { faBarcode, faSearch } from '@fortawesome/free-solid-svg-icons'
import { Subject } from 'rxjs'
import { debounceTime, filter, tap } from 'rxjs/operators'

import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import { BarcodeSubscriber } from '@skinsoft/ui'
import { keyboard$ } from '@skinsoft/ui/src/barcode/keyboard'

export const QueryInput = defineComponent({
    mixins: [reactiveVueMixin],
    // declared so a native `input` bubbling from the inner <input> isn't conflated with this
    // component's own debounced `input` emit (Vue 3 fallthrough behaviour)
    emits: ['input'],
    components: {
        sBarcodeSubscriber: BarcodeSubscriber,
    },
    props: {
        debounceTime: {
            type: Number,
            default: 750,
        },
        placeholder: String,
        barcodeEnabled: Boolean,
        autoSearch: {
            type: Boolean,
            default: true,
        },
    },
    template: require('./query-input.html'),
    data() {
        return {
            // Icons
            searchIcon: faSearch,
            barcodeIcon: faBarcode,
            value: '',
            activeBarcode: false,
            value$: new Subject(),
            // Referenced by the template (:eventFilterIdentifier), so it must live in data() rather
            // than as a module-level constant even though it's never reassigned.
            INPUT_FILTER_IDENTIFIER: 'search-query-input',
        }
    },
    mounted() {
        keyboard$
            .pipe(
                filter(
                    inputEvent => inputEvent.inputEventIdentifier === this.INPUT_FILTER_IDENTIFIER,
                ),
            )
            .subscribe(value => {
                this.value = value.char
            })

        if (this.autoSearch) {
            this.subscribeTo(this.value$.pipe(debounceTime(this.debounceTime)), value => {
                this.$emit('input', value)
            })
        }
    },
    beforeUnmount() {
        this.unsuscribeFromQueryParams()
    },
    methods: {
        performSearch() {
            this.$emit('input', this.value)
        },
        unsuscribeFromQueryParams() {
            this.unsubscribeFrom('value')
        },
        toggleBarcodeScanner() {
            this.activeBarcode = !this.activeBarcode
        },
    },
    watch: {
        value: {
            handler() {
                this.value$.next(this.value)
            },
            immediate: true,
            deep: true,
        },
    },
})
